export const standardTextLimit = 200;
export const standardLinesLimit = 3;

export const ShouldTruncate = (text: string, limit: number = standardTextLimit) => {
  return text.length > limit;
};

/* /[any character *that is not a line-break]{up to 80 - full line} or 
* [any character*] {between 1 to 80 chars long} followed by a line-break or
* [any character* followed by end of string] */

export const countLines = (text: string = '') => {  
  // eslint-disable-next-line no-control-regex
  const regexp = RegExp('[^\r\n|\r|\n]{80}|[^\r\n|\r|\n]{1,80}[\r\n|\r|\n]|[^\r\n|\r|\n]{1,80}$','g');
  let resultsArray: any;
  let lines: number = 0;

  do {
    resultsArray = regexp.exec(text);
    if (resultsArray) {
      lines++;
    } 
  } while (resultsArray !== null);
    
  return lines;
};

export const truncateStringToMaxLines = (
  text: string, 
  maxLines: number = standardLinesLimit,
  visibleTextLength: number = standardTextLimit
  ) => {
    // eslint-disable-next-line no-control-regex
    const regexp = RegExp('[^\r\n|\r|\n]{80}|[^\r\n|\r|\n]{1,80}[\r\n|\r|\n]|[^\r\n|\r|\n]{1,80}$','g');

    return text.substring(0,visibleTextLength).match(regexp).slice(0,maxLines).join('').replace(/[\r\n|\r|\n]$/,'') + '...';
};

export const ShouldTruncateTextAndLines = (
  text: string = '',  
  limit: number = standardTextLimit,
  maxLines: number = standardLinesLimit
) => {
  return text.length > limit || countLines(text) > maxLines;
};

export const CreateRenderer = (text: string, limit: number = standardTextLimit) => {
  return (collapsed: boolean) => collapsed ? `${text.substring(0, limit)}...` : text;
};
